import styled from 'styled-components';
import { colors, spacing, statusColors } from '../../../defaultTheme';
import mediaQueries from '../../../const/mediaQueries';
export const ProgressIndicatorContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin: 0;
`;
export const StepDescriptionWrapper = styled.div `
  display: inline-block;
  width: auto;
  text-align: center;
  position: absolute;
  margin-top: ${({ $placement }) => {
    switch ($placement) {
        case 'bottom':
            return '42px';
        case 'left':
        case 'right':
            return '0px';
        case 'top':
        default:
            return '-42px';
    }
}};
  margin-left: ${({ $placement }) => {
    switch ($placement) {
        case 'bottom':
        case 'top':
            return '-70px';
        case 'left':
        case 'right':
        default:
            return '0px';
    }
}};
  @media ${mediaQueries.lessThanMedium} {
    margin-top: 0px;
    margin-left: 41px;
    text-align: left;
  }
`;
export const ProgressIndicatorBarBase = styled.div `
  width: ${({ $width }) => $width}px;
  display: flex;
  flex-direction: row;
  position: relative;
  background-color: ${colors.lightGrey};
  height: ${spacing.xsmall}px;
  @media ${mediaQueries.lessThanMedium} {
    width: ${spacing.xsmall}px;
    height: 340px;
    display: flex;
    flex-direction: column;
    background-color: ${colors.lightGrey};
    margin-right: 200px;
  }
`;
export const StepGenericWrapper = styled.div `
  height: ${spacing.xlarge}px;
  width: ${spacing.xlarge}px;
  border-radius: 100%;
  position: absolute;
  top: -14px;
  border: solid ${statusColors.info.border} 2px;
  background-color: ${colors.cyanBlue};
  box-sizing: border-box;
`;
export const StepWrapper = styled(StepGenericWrapper) `
  left: ${({ $value }) => $value}%;
  @media ${mediaQueries.lessThanMedium} {
    top: ${({ $value }) => $value}%;
    left: -15px;
  }
`;
export const InitialStepWrapper = styled(StepGenericWrapper) `
  /** Setting position so that progress line starts once the initial step ends */
  left: -32px;
  @media ${mediaQueries.lessThanMedium} {
    top: -32px;
    left: -15px;
  }
`;
export const DottedLine = styled.div `
  position: absolute;
  width: ${({ $width }) => $width}%;
  border: 1px dashed ${colors.turquoise};
  top: -6px;
  @media ${mediaQueries.lessThanMedium} {
    height: ${({ $width }) => $width}%;
    width: 0px;
    left: 7px;
    top: 0px;
  }
`;
export const LineThrough = styled.div `
  position: absolute;
  width: ${({ $width }) => $width}%;
  background-color: ${colors.turquoise};
  height: 4px;
  @media ${mediaQueries.lessThanMedium} {
    height: ${({ $width }) => $width}%;
    width: 4px;
  }
`;
export const ProgressLine = styled.div `
  position: absolute;
  width: ${({ width }) => width}%;
  background-color: ${colors.cyanBlue};
  height: ${spacing.xsmall}px;
  @media ${mediaQueries.lessThanMedium} {
    height: ${({ width }) => width}%;
    width: ${spacing.xsmall}px;
  }
`;
export const TooltipArrow = styled.div `
  width: 14px;
  height: 14px;
  z-index: -1;
  &:before {
    position: absolute;
    width: 14px;
    height: 14px;
  }
  &:before {
    content: '';
    transform: rotate(45deg);
    background: ${colors.turquoise};
  }
  &:after {
    content: '';
    position: absolute;
    background: ${colors.turquoise};
  }
`;
export const TooltipContent = styled.div `
  min-width: 100px;
  max-width: 300px;
  background: ${colors.turquoise};
  color: ${colors.white};
  padding: ${spacing.xsmall}px ${spacing.medium}px;
  border-radius: ${spacing.small}px;
  text-align: center;
  text-shadow: hsla(0, 0%, 0%, 0.1) 1px 1px 1px;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 2px 0px;
  white-space: nowrap;
  &[data-popper-placement^='top'] > ${TooltipArrow} {
    bottom: -6px;
    &:after {
      width: 30px;
      height: 12px;
      bottom: 6px;
      left: -3px;
    }
  }
  &[data-popper-placement^='bottom'] > ${TooltipArrow} {
    top: -6px;
    &:after {
      width: 30px;
      height: 13px;
      top: 6px;
      left: -4px;
    }
  }
  &[data-popper-placement^='left'] > ${TooltipArrow} {
    right: -14px;
    &:before {
      top: -16px;
      right: 7px;
    }
    &:after {
      width: 14px;
      height: 22px;
      top: -20px;
      right: 14px;
    }
  }
  &[data-popper-placement^='right'] > ${TooltipArrow} {
    left: -14px;
    &:before {
      top: -16px;
      left: 7px;
    }
    &:after {
      width: 14px;
      height: 22px;
      top: -20px;
      left: 14px;
    }
  }
`;
